export * from 'server/models/Vessel';


// WEBPACK FOOTER //
// ./data/models/Vessel.ts